import { ChevronLeft } from 'lucide-react';
import Button from './Button';

/** Standard routed page header with back navigation. */
export default function PageBackHeader({
  title,
  titlePending = false,
  onBack,
  backLabel = 'Back',
  children,
  className = '',
}) {
  return (
    <div className={`mb-6 flex items-center gap-2 ${className}`}>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={onBack}
        aria-label={backLabel}
        className="!h-auto shrink-0 !p-2 -ml-2 text-gray-600 dark:text-dark-text"
      >
        <ChevronLeft className="h-6 w-6" aria-hidden />
      </Button>
      {title ? (
        <h1 className="min-w-0 flex-1 truncate text-2xl font-bold text-gray-900 dark:text-dark-text">
          {title}
        </h1>
      ) : titlePending ? (
        <span className="h-8 w-48 max-w-[70%] shrink-0 rounded skeleton-shimmer" aria-hidden />
      ) : null}
      {children}
    </div>
  );
}
